import React from 'react'
import pt from 'prop-types'

import FeederIcon from '../../icon/Feeder'
import FeederOnIcon from '../../icon/FeederOn'
import LinkWithLogin from '../../LinkWithLogin'

const Feeder = ({ pathname }) => {
  const isInFeed = pathname === '/' || pathname === '/home' || pathname.startsWith('/custom-feed')
  return (
    <div className="main-menu-item main-menu-item__feeder ">
      <div className={isInFeed ? '-withOn' : 'without'}>
        <LinkWithLogin to={'/'}>{isInFeed ? <FeederOnIcon /> : <FeederIcon />}</LinkWithLogin>
      </div>
    </div>
  )
}

Feeder.propTypes = {
  pathname: pt.string
}

export default Feeder
